const getSubString = (text, startIndex, endIndex) => {
  let result = text.substring(startIndex);
  if (result.length > endIndex) {
    return result.substring(0, endIndex) + '...';
  }
  return result;
};

export default getSubString;
